import React from 'react'

const Background = () => {
  return (
    <div className="isave-background">
      <h4>Background</h4>
      <p>
        Isave is a startup fintech company in Africa which provides financial services to indidvuduals and companies that need a platform to monitor their savings and earn interest on the saved funds by choosing to invest in any of the numerous companies listed on the application.<br />
        The company is relatively new and its concept is mostly new with little competition. An initiative undertaken by the firm is to save people’s funds from inflationary tendencies by converting funds to US dollars. Isave aims to become the major saving and platform in Africa.
      </p>
    </div>
  )
}

export default Background